import { MoreVertical, Upload } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

type Props = {
  onPickFile: () => void;
};

export default function UploadFallbackMenu({ onPickFile }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Opções"
          className="p-2 rounded-md hover:bg-muted text-ep-on-surface-variant transition-colors duration-150"
        >
          <MoreVertical className="h-5 w-5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onPickFile} className="cursor-pointer">
          <Upload className="mr-2 h-4 w-4" />
          Enviar arquivo da galeria
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
